class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector('[data-slider]');
    this.slider = null;

    window.addEventListener('resize', debounce(this.initSlider.bind(this), 100));
  }

  connectedCallback() {
    this.initSlider();
    this.initClock();
  }

  /*
  The clock feature have to be defined by Kave to know it's real behavior.
  By now it will remain disabled on the interface, but the code is here to be used in the future.
  Now it's a simple clock, but meybe will be the remaining time for an offer to be available.
  */

  initClock() {
    const clockElements = this.querySelectorAll('[data-clock-time]');

    if (clockElements.length === 0) return;

    const updateClock = () => {
      const now = new Date();
      const time = [now.getHours(), now.getMinutes(), now.getSeconds()]
        .map((unit) => String(unit).padStart(2, '0'))
        .join(':');

      clockElements.forEach((element) => {
        element.textContent = time;
      });
    };

    updateClock();
    setInterval(updateClock, 1000);
  }

  updateSliderWidth(sliderElement) {
    sliderElement.style.width = '';

    const texts = sliderElement.querySelectorAll('.announcement-bar__text');
    const maxWidth = Math.max(0, ...Array.from(texts).map((text) => text.offsetWidth));

    if (maxWidth) sliderElement.style.width = `${maxWidth}px`;
  }

  initSlider() {
    const sliderElement = this.querySelector('.splide');

    if (!sliderElement) return;

    if (window.innerWidth >= 990 && sliderElement.hasAttribute('data-slider-destroy-desktop')) {
      sliderElement.classList.add('is-initialized');

      if (this.slider !== null) {
        this.slider.destroy(true);
        this.slider = null;
      }

      return;
    }

    this.updateSliderWidth(sliderElement);

    if (this.slider !== null) {
      this.slider.refresh();
      return;
    }

    const slides = sliderElement.querySelectorAll('.splide__slide');
    const slideHeight = slides[0] ? slides[0].offsetHeight : 0;

    this.slider = new Splide(sliderElement, {
      drag: false,
      pagination: false,
      rewind: true,
      waitForTransition: false,
      arrows: false,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      direction: 'ttb',
      height: slideHeight || undefined,
      interval: Number(this.sliderElement.dataset.interval)
    }).mount();

    const toggle = this.querySelector('.announcement-bar__autoplay-toggle');

    if (toggle) {
      this.slider.on('autoplay:pause', () => toggle.classList.add('is-paused'));
      this.slider.on('autoplay:play', () => toggle.classList.remove('is-paused'));
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);
